import { checkResult } from '@/utils/tools'
import { buildUinfos } from './useBuildUinfos'
import { useRequest } from 'vue-request'
import request from '@/utils/request'
import { API_BASE } from '@Con'

export default (auth) => {
  // 切换登录角色
  const {
    data: result,
    runAsync,
    loading
  } = useRequest((payload) => request(API_BASE + '/myInfo/switchRole', payload))

  const switchAndBuildMenus = async (accountId, roleId, tenantOrgId) => {
    await runAsync({ accountId, roleId, tenantOrgId })

    if (checkResult(result.value)) {
      // 重新更新用户信息
      return buildUinfos(auth, result.value.data, roleId)
    } else {
      throw new Error(result.value.msg)
    }
  }

  return {
    loading,

    switchAndBuildMenus
  }
}
